import React, {Component} from "react";
import{
    Row,
    Col,
    Card,
    CardBody,
    CardFooter,
    UncontrolledTooltip
} from 'reactstrap';
import { Link,NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import swal from 'sweetalert';
import LoadingScreen, { __esModule } from 'react-loading-screen';
import NumberFormat from 'react-number-format';

import moment from 'moment-timezone';
import Select from "react-select";
import Breadcrumbs from '../../component/Breadcrumb';
import logo from "../../images/logo/logo.png";
import API from '../../helpers/API';
import{
    infoSession,
    showRole,
    showStatusAktif,
    saveTanggal,
    showTanggal,
    showStatusProses
} from '../../config/Utils';
import "react-datepicker/dist/react-datepicker.css";
moment.tz.setDefault("Asia/Makassar");

const date_now = new Date();

class Produk extends Component {
    constructor(props){
        super(props);
        this.state = {
            isReady:false,
            isLoading:false,
            xOperator:infoSession('id'),
            dataSatuan:[],
            dataMitra:[],
            dataTable:[],
            dataDetail:[],
            dataPatrun:[],
            dataSewing:[],
            dataBeading:[],
            fTglAwal:date_now,
            fTglAkhir:new Date().setDate(date_now.getDate()+1),
            fMitra:'',
            fNoProduksi:'',
            fDeskripsi:'',

            //input
            xId:'',
            xTglProses: new Date(),
            xStatusProses:'',
            xMitra:'',
            xKeterangan:'',
            xJumlah:'',
            xSatuan:'',

            xTglSelesai:'',
            xStatusSelesai:'T',

            xKeteranganCancel:'',
            //kirim
            xPengirim:'',
            xPenerima:'',
            xNamaItem:'',
            xColor:'',
            xColorScr:'',
            xSize:'',
            xSatuan:'',
            xJumlah:'',

            xJumlahKirim:'',
            xSatuanKirim:'',
            xProsesKirim:'',
        }
        this._handleInputChange=this._handleInputChange.bind(this);
    }

    _handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    _handleInputChangeDate (event, name) {
        this.setState({
            [name]:event
        });
    };

    _handleInputChangeDateFilter (event) {
        //console.log(event);
        const [start, end] = event;
        this.setState({
            ['fTglAwal']:start,
            ['fTglAkhir']:end
        })
    };

    _handleInputChangeSelected(event, name){
        if(event){
            this.setState({
                [name]: event,
            })
        }
    };

    _clearFilter(){
        this.setState({
            fTglAwal:'',
            fTglAkhir:'',
            fMitra:'',
            fNoProduksi:'',
            fDeskripsi:''
        })
    }

    _clearBox(){
        this.setState({
            dataDetail:[],
            xId:'',
            xTglProses: new Date(),
            xStatusProses:'',
            xMitra:'',
            xKeterangan:'',
            xJumlah:'',
            xSatuan:'',

            xTglSelesai:'',
            xStatusSelesai:'T',

            xKeteranganCancel:'',
            //kirim
            xPengirim:'',
            xPenerima:'',
            xNamaItem:'',
            xColor:'',
            xColorScr:'',
            xSize:'',
            xSatuan:'',
            xJumlah:'',

            xJumlahKirim:'',
            xSatuanKirim:'',
            xProsesKirim:'',
        })
    }

    _loadDataMitra(){
        var filter = {
            kategori:''
        };

        API.get('mitra', {params:filter}).then(res=>{
            let ar = [];
            let ar_patrun = [];
            let ar_sewing = [];
            let ar_beading = [];
            if(res.data.result){
                if(res.data.data.length){
                    //console.log(res.data.data);
                    ar = res.data.data;
                    res.data.data.map((item, index)=>{
                        //let ar = JSON.parse(item[3]);
                        if(item[3].includes('00')){
                            ar_patrun.push(item)  
                        };

                        if(item[3].includes('01')){
                            ar_sewing.push(item)
                        };

                        if(item[3].includes('02')){
                            ar_beading.push(item)
                        };
                    })
                };
            };

            this.setState({
                dataMitra:ar,
                dataPatrun:ar_patrun,
                dataSewing:ar_sewing,
                dataBeading:ar_beading,
            });
        })
    }

    _loadDataSatuan(){
        API.get('satuan').then(res=>{
            let ar = [];
            if(res.data.result){
                if(res.data.data.length){
                    ar = res.data.data;
                };
            };
            this.setState({
                dataSatuan:ar,
            })
        })
    }

    _loadDataTable(param){
        var filter = {
            mitra:this.state.fMitra.value,
            no_produksi:this.state.fNoProduksi,
            deskripsi:this.state.fDeskripsi,
            status_proses:''
        };

        API.get('produksi',{params:filter}).then(res=>{
            let ar = [];
            if(res){
                if(res.data.result){
                    if(res.data.data.length){
                        ar = res.data.data;
                    };
                };
            }
            this.setState({
                dataTable:ar,
                isLoading:false,
                isReady:true
            })
        });
    }

    _loadDetail(param){
        var filter = {
            no:param
        };

        API.get('produksi/detail',{params:filter}).then(res=>{
            let ar = [];
            if(res){
                if(res.data.result){
                    ar = res.data.data;
                }
            }
            this.setState({
                dataDetail:ar
            })
        })
    }

    _loadData(item){
        this._clearBox();
        if(item){
            this.setState({
                xId:item[0],
                xTglProses: new Date(item[5]),
                xStatusProses:item[3],
                xMitra:{value:item[6],label:item[16]},
                xKeterangan:item[4],
                xJumlah:item[13],
                xSatuan:{value:item[12],label:item[18]},

                xTglSelesai:'',
                xStatusSelesai:'T',

                xKeteranganCancel:'',
                //kirim
                xPengirim:item[6],
                xPenerima:'',
                xNamaItem:item[8],
                xColor:item[9],
                xColorScr:item[10],
                xSize:item[11],
                xSatuanKirim:item[12],
                xJumlahkirim:'',
            });
            this._loadDetail(item[0]);
        }
    }

    _loading(status){
        this.setState({
            isLoading:status
        });
    }

    _notif(type,title,message){
        swal({
            title: title,
            text: message,
            icon: type,
        });
    }

    _add(){
        if(!this.state.xTglProses){
            this._notif('error', 'Error', 'Proses Date cannot be empty');
            return false;
        };

        if(!this.state.xMitra){
            this._notif('error', 'Error', 'Patrun cannot be empty');
            return false;
        };

        if(!this.state.xKeterangan){
            this._notif('error', 'Error', 'Description cannot be empty');
            return false;
        };

        if(!this.state.xJumlah){
            this._notif('error', 'Error', 'Qty cannot be empty');
            return false;
        };

        if(eval(this.state.xJumlah)<=0){
            this._notif('error', 'Error', 'Qty cannot be 0 or minus');
            return false;
        };

        if(!this.state.xSatuan){
            this._notif('error', 'Error', 'Unit cannot be empty');
            return false;
        };

        var param = {
            user:this.state.xOperator,
            status_proses:this.state.xStatusProses,
            tgl_proses:saveTanggal(this.state.xTglProses),
            mitra:this.state.xMitra.value,
            dari:this.state.xOperator,
            keterangan:this.state.xKeterangan,
            jumlah:this.state.xJumlah,
            satuan:this.state.xSatuan.value,
            nama_item:this.state.xNamaItem,
            color:this.state.xColor,
            color_scr:this.state.xColorScr,
            size:this.state.xSize,
            status_selesai:this.state.xStatusSelesai
            
        };

        this._loading(true);
        API.post('produksi',param).then(res=>{
            if(res){
                if(res.data.result){
                    document.getElementById('btn-batal-form').click();
                    this._loading(false);
                    this._clearBox();
                    this._loadDataTable();
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(true);
                this._notif('error', 'Error', "Can't connect to server");
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })

    }

    _update(){
        if(!this.state.xTglProses){
            this._notif('error', 'Error', 'Proses Date cannot be empty');
            return false;
        };

        if(!this.state.xMitra){
            this._notif('error', 'Error', 'Patrun cannot be empty');
            return false;
        };

        if(!this.state.xKeterangan){
            this._notif('error', 'Error', 'Description cannot be empty');
            return false;
        };

        if(!this.state.xJumlah){
            this._notif('error', 'Error', 'Qty cannot be empty');
            return false;
        };

        if(eval(this.state.xJumlah)<=0){
            this._notif('error', 'Error', 'Qty cannot be 0 or minus');
            return false;
        };

        if(!this.state.xSatuan){
            this._notif('error', 'Error', 'Unit cannot be empty');
            return false;
        };

        var param = {
            user:this.state.xOperator,
            status_proses:this.state.xStatusProses,
            tgl_proses:saveTanggal(this.state.xTglProses),
            mitra:this.state.xMitra.value,
            dari:this.state.xOperator,
            keterangan:this.state.xKeterangan,
            jumlah:this.state.xJumlah,
            satuan:this.state.xSatuan.value,
            nama_item:this.state.xNamaItem,
            color:this.state.xColor,
            color_scr:this.state.xColorScr,
            size:this.state.xSize,
            status_selesai:this.state.xStatusSelesai
            
        };

        this._loading(true);
        API.put('produksi/'+this.state.xId,param).then(res=>{
            if(res){
                if(res.data.result){
                    document.getElementById('btn-batal-form').click();
                    this._loading(false);
                    this._clearBox();
                    this._loadDataTable();
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(true);
                this._notif('error', 'Error', "Can't connect to server");
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })
    }

    _cancel(){
        if(!this.state.xKeteranganCancel){
            this._notif('error', 'Error', 'Reason for cancellation cannot be empty');
            return false;
        }

        var param={
            keterangan_cancel:this.state.xKeteranganCancel,
            user:this.state.xOperator,
            status_proses:'99',

            tgl_proses:saveTanggal(new Date()),
            mitra:this.state.xMitra.value,
            dari:this.state.xOperator,
            keterangan:this.state.xKeterangan,
            jumlah:this.state.xJumlah,
            satuan:this.state.xSatuan.value,
            nama_item:this.state.xNamaItem,
            color:this.state.xColor,
            color_scr:this.state.xColorScr,
            size:this.state.xSize,
        };

        API.put('produksi/cancel/'+this.state.xId,param).then(res=>{
            if(res){
                if(res.data.result){
                    document.getElementById('btn-batal-form').click();
                    this._loading(false);
                    this._clearBox();
                    this._loadDataTable();
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(true);
                this._notif('error', 'Error', "Can't connect to server");
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })

    }

    _kirim(status){
        if(!this.state.xPenerima){
            this._notif('error', 'Error', 'Item name cannot be empty');
            return false;  
        };

        if(!this.state.xNamaItem){
            this._notif('error', 'Error', 'Item name cannot be empty');
            return false;
        };

        if(!this.state.xColor){
            this._notif('error', 'Error', 'Color cannot be empty');
            return false;
        };

        if(!this.state.xColorScr){
            this._notif('error', 'Error', 'Color scr cannot be empty');
            return false;
        };

        if(!this.state.xSize){
            this._notif('error', 'Error', 'Size cannot be empty');
            return false;
        };

        if(!this.state.xSatuan){
            this._notif('error', 'Error', 'Unit cannot be empty');
            return false;
        };

        if(!this.state.xJumlahKirim){
            this._notif('error', 'Error', 'Qty cannot be empty');
            return false;
        };

        if(!this.state.xStatusSelesai){
            this._notif('error', 'Error', 'Status cannot be empty');
            return false;
        };

        var param = {
            tgl_proses:saveTanggal(this.state.xTglProses),
            dari:this.state.xPengirim,
            mitra:this.state.xPenerima.value,
            nama_item:this.state.xNamaItem,
            keterangan:this.state.xKeterangan,
            color:this.state.xColor,
            color_scr:this.state.xColorScr,
            size:this.state.xSize,
            satuan:this.state.xSatuan.value,
            jumlah:this.state.xJumlahKirim,
            status_selesai:this.state.xStatusSelesai,
            user:this.state.xOperator,
            status_proses:status
        };
        API.put('produksi/kirim/'+this.state.xId, param).then(res=>{
            if(res){
                if(res.data.result){
                    if(document.getElementById('btn-batal-sewing')){
                        document.getElementById('btn-batal-sewing').click();
                    };

                    if(document.getElementById('btn-batal-beading')){
                        document.getElementById('btn-batal-beading').click();
                    };
                    this._loading(false);
                    this._clearBox();
                    this._loadDataTable();
                }else{
                    this._loading(false);
                    this._notif('error', 'Error', res.data.message);
                    return false;
                }
            }else{
                this._loading(true);
                this._notif('error', 'Error', "Can't connect to server");
                return false;
            }
        }).catch(error=>{
            this._loading(false);
            this._notif('error', 'Error', error.message);
            return false;
        })
    }

    _submit(){
        if(this.state.xId){
            this._update();
        }else{
            this._add();
        }
    }

    componentDidMount() {
        if(this.state.isLoading){
            if(this.state.isLoading){
                this.setState({
                    isReady:true,
                    isLoading:false
                });
            }
        }
    }

    render(){
        if(!this.state.isReady){
            this.setState({
                isReady:true,
                isLoading:false
            });
            this._loadDataMitra();
            this._loadDataSatuan();
            this._loadDataTable(this.state.fCari);
        };

        return(
            <React.Fragment>
                <LoadingScreen
                    loading={this.state.isLoading}
                    bgColor='#f1f1f1'
                    spinnerColor='#9ee5f8'
                    textColor='#676767'
                    logoSrc={logo}
                    text=''
                >
                    <Breadcrumbs title="K & I" breadcrumbItem="STOK / PRODUCT" />
                    <Row>
                        <Col>
                            <div className="card shadow-none border">
                                <div className='card-body'>
                                    <Row>
                                        <Col xl={6} md={6} sm={12} xs={12}>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Date</span>
                                                </div>
                                                <div className="col-md-8">
                                                <DatePicker
                                                    className="form-control input-bg-white"
                                                    dateFormat="dd/MM/yyyy"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    //popperPlacement='bottom-right'
                                                    popperModifiers={{
                                                        flip: {
                                                            behavior: ["bottom"] // don't allow it to flip to be above
                                                        },
                                                        preventOverflow: {
                                                            enabled: false // tell it not to try to stay within the view (this prevents the popper from covering the element you clicked)
                                                        },
                                                        hide: {
                                                            enabled: false // turn off since needs preventOverflow to be enabled
                                                        }
                                                    }}
                                                    selectsRange={true}
                                                    startDate={this.state.fTglAwal}
                                                    endDate={this.state.fTglAkhir}
                                                    onChange={(update) => {
                                                        this._handleInputChangeDateFilter(update);
                                                    }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Patner</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <Select value={this.state.fMitra} name="fMitra" options={this.state.dataMitra.map(e=>({value:e[0], label:e[2]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"fMitra")}} />
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xl={6} md={6} sm={12} xs={12}>
                                            <div className="input-group mb-3">
                                                <div className="col-md-4">
                                                    <span className="input-group-text">Description</span>
                                                </div>
                                                <div className="col-md-8">
                                                    <input type="text" className="form-control" name="fDeskripsi" value={this.state.fDeskripsi} onChange={this._handleInputChange.bind(this)}></input>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xl={8} md={8} sm={12} xs={12}></Col>
                                        <Col xl={4} md={4} sm={12} xs={12}>
                                            <button type="button" className="btn btn-primary btn-flat btn-block waves-effect waves-light float-end mr-2" onClick={()=>{
                                                this._loadDataTable();
                                             }}>Filter</button> 
                                        </Col>
                                    </Row>

                                </div>
                            </div>
                        </Col>
                        
                    </Row>

                    <Row>
                        <Col>
                            <div className="btn-group p-2" role="group">

                                <button type="button" className="btn btn-primary mr-2" onClick={()=>{
                                    //this._clearBox()
                                }}>
                                <i className="fas fa-download"></i> Export to Excel
                                </button>

                                <button type="button" className="btn btn-primary" onClick={()=>{
                                    window.location.reload(true);
                                }}>
                                <i className="fas fa-recycle"></i> Refresh
                                </button>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <Col xl={12} md={12} sm={12} xs={12}>
                            <div className="card shadow-none border">
                                <div className='card-body'>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{width:'100px'}}>STATUS PROSES</th>
                                                    <th scope="col" style={{width:'100px'}}>DATE</th>
                                                    <th scope="col">PATRUN</th>
                                                    <th scope="col">DESCRIPTION</th>
                                                    <th scope="col" style={{width:'100px'}}>QTY</th>
                                                    <th scope="col" style={{width:'100px'}}>UNIT</th>
                                                    <th style={{width:'100px'}}></th> 
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.dataTable.map((item, index)=>{
                                                        return(
                                                            <React.Fragment key={"f_"+index}>
                                                                <tr key={'row_'+index}>
                                                                    <td>{showStatusProses(item[3])}</td>
                                                                    <td>{item[5]}</td>
                                                                    <td>{item[16]}</td>
                                                                    <td>{item[4]}</td>
                                                                    <td>{item[13]}</td>
                                                                    <td>{item[18]}</td>
                                                                    <td style={{textAlign:"center"}}>
                                                                        <div className="dropdown">
                                                                            <NavLink to="#" className="font-size-16 text-muted dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true">
                                                                                <i className="fas fa-ellipsis-h fa-lg"></i>
                                                                            </NavLink>
                                                                            <div className="dropdown-menu dropdown-menu-end">
                                                                                <a className="dropdown-item" data-toggle="modal" data-target="#modal-form" onClick={()=>{
                                                                                    this._loadData(item);
                                                                                }}><i className="fas fa-search mr-2"></i> Detail</a>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </React.Fragment>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div id="modal-form" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Description</div>
                                                    <div className='profile-info-value'>
                                                        {this.state.xKeterangan}
                                                    </div>
                                                </div>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Item Name</div>
                                                    <div className='profile-info-value'>
                                                        {this.state.xNamaItem}
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Color</div>
                                                    <div className='profile-info-value'>
                                                        {this.state.xColor}
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Color Scr</div>
                                                    <div className='profile-info-value'>
                                                        {this.state.xColorScr}
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Size</div>
                                                    <div className='profile-info-value'>
                                                        {this.state.xSize}
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Qty</div>
                                                    <div className='profile-info-value'>
                                                        {this.state.xJumlah}
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Unit</div>
                                                    <div className='profile-info-value'>
                                                      {this.state.xSatuan.label}
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className="mt-2">
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className="card shadow-none border">
                                                <div className='card-body'>
                                                    <div className="table-header">
                                                        History
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table align-middle table-nowrap table-hover mb-0">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" style={{width:'100px'}}>STATUS PROSES</th>
                                                                <th scope="col" style={{width:'100px'}}>DATE</th>
                                                                <th scope="col">FROM</th>
                                                                <th scope="col">TO</th>
                                                                <th scope="col">DESCRIPTION</th>
                                                                <th scope="col" style={{width:'100px'}}>QTY</th>
                                                                <th scope="col" style={{width:'100px'}}>UNIT</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.dataDetail.map((item, index)=>{
                                                                    return(
                                                                        <React.Fragment key={"f_"+index}>
                                                                            <tr key={'row_'+index}>

                                                                            </tr>
                                                                        </React.Fragment>
                                                                    )
                                                                    })
                                                            }
                                                        </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button id="btn-batal-form" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="modal-cancel" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Explanation</div>
                                                    <div className='profile-info-value'>
                                                        <textarea className="form-control" name="xKeteranganCancel" value={this.state.xKeteranganCancel} onChange={this._handleInputChange.bind(this)}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._cancel();
                                    }}>Save</button>
                                    <button id="btn-batal-hapus" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div id="modal-kirim-sewing" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Date</div>
                                                    <div className='profile-info-value'>
                                                    <DatePicker
                                                        className="form-control input-bg-white"
                                                        dateFormat="dd/MM/yyyy"
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={this.state.xTglProses}
                                                        onChange={(update) => {
                                                            this._handleInputChangeDate(update, 'xTglProses');
                                                        }}
                                                    />
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Sent to</div>
                                                    <div className='profile-info-value'>
                                                        <Select value={this.state.xPenerima} name="xPenerima" options={this.state.dataSewing.map(e=>({value:e[0], label:e[2]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xPenerima")}} />
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Item Name</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xNamaItem" value={this.state.xNamaItem} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Color</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xColor" value={this.state.xColor} onChange={this._handleInputChange.bind(this)} ></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Color Scr</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xColorScr" value={this.state.xColorScr} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Size</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xSize" value={this.state.xSize} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Qty</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xJumlahKirim" value={this.state.xJumlahKirim} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Unit</div>
                                                    <div className='profile-info-value'>
                                                        <Select value={this.state.xSatuan} name="xSatuan" options={this.state.dataSatuan.map(e=>({value:e[0], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xSatuan")}} />
                                                    </div>
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._kirim('01');
                                    }}>Send</button>
                                    <button id="btn-batal-sewing" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div id="modal-kirim-beading" className="modal fade-scale" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header no-padding">
                                    <h5 className="modal-title"></h5>
                                    <button type="button" className="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                        <Col xl={12} md={12} sm={12} xs={12}>
                                            <div className='profile-user-info profile-user-info-striped'>
                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Date</div>
                                                    <div className='profile-info-value'>
                                                    <DatePicker
                                                        className="form-control input-bg-white"
                                                        dateFormat="dd/MM/yyyy"
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={this.state.xTglProses}
                                                        onChange={(update) => {
                                                            this._handleInputChangeDate(update, 'xTglProses');
                                                        }}
                                                    />
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Sent to</div>
                                                    <div className='profile-info-value'>
                                                        <Select value={this.state.xPenerima} name="xPenerima" options={this.state.dataBeading.map(e=>({value:e[0], label:e[2]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xPenerima")}} />
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Item Name</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xNamaItem" value={this.state.xNamaItem} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Color</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xColor" value={this.state.xColor} onChange={this._handleInputChange.bind(this)} ></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Color Scr</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xColorScr" value={this.state.xColorScr} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Size</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xSize" value={this.state.xSize} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Qty</div>
                                                    <div className='profile-info-value'>
                                                        <input type="text" className="form-control" name="xJumlahKirim" value={this.state.xJumlahKirim} onChange={this._handleInputChange.bind(this)}></input>
                                                    </div>
                                                </div>

                                                <div className='profile-info-row'>
                                                    <div className='profile-info-name'>Unit</div>
                                                    <div className='profile-info-value'>
                                                        <Select value={this.state.xSatuan} name="xSatuan" options={this.state.dataSatuan.map(e=>({value:e[0], label:e[1]}))} onChange={(e)=>{this._handleInputChangeSelected(e,"xSatuan")}} />
                                                    </div>
                                                </div>

                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-white btn-primary btn-round" onClick={()=>{
                                        this._kirim('02');
                                    }}>Send</button>
                                    <button id="btn-batal-beading" data-dismiss="modal" className="btn btn-white btn-danger btn-round" style={{marginLeft:'5px'}}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </LoadingScreen>
            </React.Fragment>
        )
    }







}

export default Produk;